import React from 'react';
import Paper from "@material-ui/core/Paper/index";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Divider} from "@material-ui/core";
import {Checkbox} from 'primereact/checkbox';
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const EditAccountView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <div className="p-grid">
                    <div className="p-col-8">
                        <TitlePage title="Administración \ Cuentas y Bóvedas \ Editar Cuenta"/>
                    </div>
                    <div className="p-col-4" align="right">
                        <Button label="Cancelar" className="p-button-secondary"
                                onClick={props.returnMaintenancePage}/>&nbsp;
                        <Button label="Guardar" onClick={props.editAccount}/>
                    </div>
                    <div className="p-col-12">
                        <Divider/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="ID Institución" isBold={true}/>
                        <SubtitleLabel header={props.datosCuenta.idInst}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Folio Institución" isBold={true}/>
                        <SubtitleLabel header={props.datosCuenta.folioInst}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Cuenta" isBold={true}/>
                        <SubtitleLabel header={props.datosCuenta.cuenta}/>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Descripción" isBold={true}/>
                        <InputText name="descrCuenta" placeholder="Ex: Descripción"
                                   required={true}
                                   maxLength={50} value={props.datosCuenta.descrCuenta}
                                   onChange={props.onChangeInputText}
                                   className={props.errors.descrCuenta ? props.errorClass : ""}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Bóveda" isBold={true}/>
                        <InputText name="boveda" placeholder="Ex: 9999"
                                   keyfilter="pint" required={true}
                                   maxLength={4} value={props.datosCuenta.boveda}
                                   onChange={props.onChangeInputText}
                                   className={props.errors.boveda ? props.errorClass : ""}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Nombre Bóveda" isBold={true}/>
                        <InputText name="nombreCorto" placeholder="Ex: Nombre"
                                   required={true}
                                   maxLength={50} value={props.datosCuenta.nombreCorto}
                                   onChange={props.onChangeInputText}
                                   className={props.errors.nombreCorto ? props.errorClass : ""}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Tipo de Cuenta" isBold={true}/>
                        <Checkbox inputId="tipoCta" value="Efectivo"
                                  checked={props.efectivoCheck}
                                  onChange={props.onChangeSelectBox}/>
                        <label htmlFor="tipoCta" className="p-checkbox-label">Efectivo</label>
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-6">
                        <SubtitleLabel header="Número de Cuenta" isBold={true}/>
                        <InputText name="cuentaEfectivo" placeholder="Ex: 01029292"
                                   keyfilter="alphanum" maxLength={50}
                                   value={props.datosCuenta.cuentaEfectivo}
                                   onChange={props.onChangeInputText}/>
                    </div>

                    {props.datosCuenta.cuentaValorGSS !== undefined && props.datosCuenta.cuentaValorGSS > 0 &&

                        <div className="p-col-12 p-md-6 p-lg-6">
                            <SubtitleLabel header="Safekeeping" isBold={true}/>
                            <InputText name="cuentaValorGSS"
                                       keyfilter="pint"
                                       placeholder={"Ex: 99999999"}
                                       maxLength={8}
                                       value={props.datosCuenta.cuentaValorGSS}
                                       onChange={props.onChangeInputText}/>
                        </div>
                    }
                </div>
            </Paper>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(EditAccountView);